import type { ITag, ITagInputValue } from '../types';

const formatTags = (list?: ITag[] | null): ITag[] => {
  if (!Array.isArray(list) || !list.length) return [];
  const tags = [];
  for (const item of list) {
    const { value, text, valid } = item || {};
    const valueTmp = value?.trim();
    const textTmp = text?.trim();
    if (!valueTmp) continue;
    tags.push({
      value: valueTmp,
      text: textTmp || '',
      valid: !!valid,
    });
  }
  return tags;
};

export const convert2Tags = (
  str: string,
  props: {
    tags: ITag[];
    splitter: string;
    getTagText?: (tag: string) => string;
    validateTag?: (tag: string) => boolean;
  },
): ITag[] => {
  const { tags, splitter, getTagText, validateTag } = props || {};

  const result: ITag[] = [];
  const tagsValues = tags?.map((tag) => tag?.value) || [];
  const emails = str?.split(new RegExp(`\\s*${splitter}\\s*`)) || [];

  for (const email of emails) {
    const emailTrim = email?.trim();
    if (!emailTrim || tagsValues?.includes(emailTrim)) continue;
    const isTagValid = validateTag?.(emailTrim) ?? true;
    result.push({
      value: emailTrim,
      text: getTagText?.(emailTrim) ?? emailTrim,
      valid: isTagValid,
    });
  }

  return result;
};

export const getTagInputValue = (payload: ITagInputValue | null): ITagInputValue => {
  const { tags, input } = payload || {};
  return { tags: formatTags(tags), input: input || '' };
};
